import * as React from 'react';

import { Outlet } from 'react-router-dom';

import { ToastContainer as PolluxToastContainer } from '@pricemoov/pollux-react';

import SuspensePageFallback from 'redesign/components/common/SuspensePageFallback';
import AppVersionManager from 'redesign/components/common/contexts/AppVersionManager';
import BeamerManager from 'redesign/components/common/contexts/BeamerManager';
import CarrierManager from 'redesign/components/common/contexts/CarrierManager';
import ConfigManager from 'redesign/components/common/contexts/ConfigManager';
import LegacyFiltersManager from 'redesign/components/common/contexts/LegacyFiltersManager';
import LocalStorageManager from 'redesign/components/common/contexts/LocalStorageManager';
import ProductCatalogMetadataManager from 'redesign/components/common/contexts/ProductCatalogMetadataManager';
import { FeatureFlagManager } from 'redesign/middlewares/FeatureFlagManager/FeatureFlagManager';

function AppLayout() {
    return (
        <ConfigManager>
            <ProductCatalogMetadataManager>
                <FeatureFlagManager>
                    <LocalStorageManager>
                        <AppVersionManager>
                            <CarrierManager>
                                <LegacyFiltersManager>
                                    <BeamerManager>
                                        <div id="layout">
                                            <React.Suspense
                                                fallback={<SuspensePageFallback withLogo />}
                                            >
                                                <Outlet />
                                            </React.Suspense>
                                            <PolluxToastContainer />
                                        </div>
                                    </BeamerManager>
                                </LegacyFiltersManager>
                            </CarrierManager>
                        </AppVersionManager>
                    </LocalStorageManager>
                </FeatureFlagManager>
            </ProductCatalogMetadataManager>
        </ConfigManager>
    );
}

export default AppLayout;
